import { t } from 'i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import { IconName } from '@lib/components/Modal/enums';
import { materialSymbolsOutlined } from '@lib/enums/common';

interface WidgetsViewEmptyStateProps {
  isViewOnly: boolean;
  isDefault: boolean;
  onCustomize: () => void;
}

export default function WidgetsViewEmptyState({
  isViewOnly,
  isDefault,
  onCustomize,
}: WidgetsViewEmptyStateProps) {
  const actions = isViewOnly
    ? undefined
    : [
        <Button
          key="customize"
          leftIcon="settings"
          leftIconClassName={materialSymbolsOutlined}
          buttonText={
            isDefault
              ? t('home.customize-company-view')
              : t('home.customize-current-view')
          }
          buttonType={ButtonTypes.primaryFilled}
          onClick={onCustomize}
        />,
      ];

  const title = isDefault
    ? t('home.empty-state-title')
    : t('home.custom-empty-state-title');

  const text = isDefault
    ? t('home.empty-state-description')
    : t('home.custom-empty-state-description');

  return (
    <EmptyState
      icon={IconName.Cancel}
      title={title}
      text={text}
      actions={actions}
    />
  );
}
